const GRAY_CLASS_NAME = 'editor-gray-mode'

// テキストエディタの背景色変更
const setup = function (editor) {
  editor.ui.registry.addIcon(
    'change_color_mode',
    '<img src="/static/change_color_mode_button.png" style="height: 24px; width: 24px; margin-top: 2px;" title="背景色変更"/>'
  )

  editor.ui.registry.addButton('changeColorMode', {
    icon: 'change_color_mode',
    tooltip: '背景色変更',
    onAction: () => {
      const editorElement = editor.getBody()
      // グレーモードのクラスがあれば削除、なければ追加
      if (editorElement.classList.contains(GRAY_CLASS_NAME)) {
        editorElement.classList.remove(GRAY_CLASS_NAME)
      } else {
        editorElement.classList.add(GRAY_CLASS_NAME)
      }
    },
  })
}

export default { setup }
